import React from 'react';
import clsx from 'clsx';
import { Box, Collapse, Grid, IconButton } from '@mui/material';

import Icon from '../../../Icon';
import ListRefreshButton from '../../../buttons/ListRefreshButton';
import Search from '../../../filter/Search';
import Pagination from '../../../filter/Pagination';
import PaginationOrder from '../../../filter/PaginationOrder';
import SelectAllItemsCheckbox from '../../../buttons/SelectAllItemsCheckbox';

import { type PaginationBaseProps } from './ViewPagination';
import PaginationButtons from './PaginationButtons';

export default function SmartphonePagination(props: PaginationBaseProps) {
	const { filterProps, orderProps, paginatorProps } = props.paginationProps;

	const [collapsed, setCollapsed] = React.useState(true);

	return (
		<Box className={clsx('p-8', props.className)}>
			<Grid container direction="column" spacing={1}>
				<Grid>
					<Collapse in={!collapsed} collapsedSize={36}>
						<Grid container direction="column" spacing={1}>
							<Grid>
								<Grid container spacing={1}>
									{props.showFilters && filterProps && (
										<Grid size="grow">
											<Search
												module={props.module}
												filters={filterProps.filters}
												handleFilterChange={filterProps.handleFilterChange}
												handleFiltersApply={filterProps.handleFiltersApply}
											/>
										</Grid>
									)}
									<Grid>
										<IconButton size="small" onClick={() => setCollapsed(state => !state)}>
											<Icon icon={collapsed ? 'expand-more' : 'expand-less'} />
										</IconButton>
									</Grid>
								</Grid>
							</Grid>
							<Grid>
								<Grid container justifyContent="space-between" alignItems="center" spacing={1}>
									<Grid>
										<Grid container alignItems="center" spacing={1}>
											{props.isSelecting && (
												<Grid>
													<SelectAllItemsCheckbox selectedItems={props.selectedItems} />
												</Grid>
											)}
											<Grid>
												<ListRefreshButton
													isLoading={paginatorProps.isLoading}
													updateRefresh={props.updateRefresh}
												/>
											</Grid>
											{((props.showFilters && props.visibleFilters) ||
												props.showExportButton ||
												!!props.additionalButtons) && (
												<Grid>
													<PaginationButtons
														module={props.module}
														filterProps={filterProps}
														visibleFilters={props.visibleFilters}
														additionalButtons={props.additionalButtons}
														showFilters={props.showFilters}
														showExportButton={props.showExportButton}
													/>
												</Grid>
											)}
										</Grid>
									</Grid>
									{props.showOrder && props.visibleOrderFilters && (
										<Grid>
											<PaginationOrder module={props.module} {...orderProps} />
										</Grid>
									)}
								</Grid>
							</Grid>
						</Grid>
					</Collapse>
				</Grid>
				<Grid>
					<Pagination {...paginatorProps} />
				</Grid>
			</Grid>
		</Box>
	);
}
